export default __webpack_public_path__ + "static/media/thumbsup_120x117.c10c29f2.svg";